import { gsap } from 'gsap'
import Cookies from 'js-cookie'

export class Loading {
  constructor() {
    this.isLoaded = false
    this.cookieName = 'uni-skateboard'
    this.body = document.body
    this.loadingEl = document.getElementById('js-loading')
    this.iconImgEl = this.loadingEl?.querySelector('.c-loading__icon__img')
    this.innerEl = this.loadingEl?.querySelector('.c-loading__inner')
    this.iconEl = this.loadingEl?.querySelector('.c-loading__icon')
    this.skateboardEl = this.loadingEl?.querySelector('.c-loading__skateboard')
    this.minDuration = 4000 // 最低4秒
    this.startTime = null
    this.loadProgress = 0
    this.targetProgress = 0
    this.animationFrame = null
    
    this.init()
  }

  init() {
    const cookie = Cookies.get(this.cookieName)
    
    if (!cookie) {
      // 初回訪問時 - is-loadedを付与しない
      this.body.classList.add('is-opening', 'is-start')
      this.startTime = Date.now()
      this.showLoading()
      this.setupEvents()
      this.setCookie()
      this.startProgressAnimation()
    } else {
      // 2回目以降の訪問時
      this.body.classList.add('is-start')
      this.loadingEl?.classList.add('is-cookie')
      this.setupEvents()
    }
  }

  showLoading() {
    if (!this.loadingEl || !this.iconImgEl || !this.innerEl || !this.iconEl) return

    // ローディング画面を表示
    gsap.set(this.loadingEl, { opacity: 1 })
    gsap.set(this.innerEl, { opacity: 1 })
    
    // アイコンを一番左端に配置
    gsap.set(this.iconImgEl, {
      left: 0,
      x: 0,
      opacity: 1
    })
  }

  setupEvents() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.onDOMReady()
      })
    } else {
      this.onDOMReady()
    }

    if (document.readyState === 'complete') {
      this.onLoad()
    } else {
      window.addEventListener('load', () => {
        this.onLoad()
      })
    }
  }

  onDOMReady() {
    this.body.classList.add('is-ready')
    this.targetProgress = 0.35
  }

  onLoad() {
    const cookie = Cookies.get(this.cookieName)
    
    if (!cookie || this.body.classList.contains('is-opening')) {
      this.targetProgress = 0.7
      
      // 最低3秒経過後に100%完了させる
      const elapsedTime = Date.now() - this.startTime
      const remainingTime = Math.max(0, this.minDuration - elapsedTime)
      
      setTimeout(() => {
        this.targetProgress = 1.0
        // 100%到達後、少し待ってからフェードアウト
        setTimeout(() => {
          this.finishLoading()
        }, 300)
      }, remainingTime)
    } else {
      // 2回目以降は即座にKVアニメーション開始
      this.body.classList.add('is-loaded')
      this.isLoaded = true
    }
  }

  startProgressAnimation() {
    if (!this.iconImgEl || !this.skateboardEl) return

    const skateboardWidth = this.skateboardEl.offsetWidth
    const iconImgWidth = this.iconImgEl.offsetWidth
    const maxDistance = skateboardWidth - iconImgWidth

    const animate = () => {
      // 現在の進捗を目標進捗に向けて滑らかに更新
      this.loadProgress += (this.targetProgress - this.loadProgress) * 0.1
      
      // アイコンの位置を更新
      const currentX = maxDistance * this.loadProgress
      gsap.set(this.iconImgEl, { x: currentX })
      
      // 100%に到達していなければ継続
      if (this.loadProgress < 0.99) {
        this.animationFrame = requestAnimationFrame(animate)
      }
    }

    this.animationFrame = requestAnimationFrame(animate)
  }

  finishLoading() {
    // アニメーションフレームをキャンセル
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame)
    }

    // ローディング画面全体をフェードアウト
    gsap.to(this.innerEl, {
      opacity: 0,
      duration: 0.4,
      onComplete: () => {
        gsap.to(this.loadingEl, {
          opacity: 0,
          duration: 0.4,
          onComplete: () => {
            // ローディング完了後にis-loadedを付与してKVアニメーション開始
            this.body.classList.add('is-loaded')
            this.isLoaded = true
            // ローディング要素を完全に非表示
            this.loadingEl.style.display = 'none'
          }
        })
      }
    })
  }

  setCookie() {
    const date = new Date()
    date.setTime(date.getTime() + (10 * 60 * 1000)) // 10分
    Cookies.set(this.cookieName, '1', {
      expires: date,
      sameSite: 'lax'
    })
  }
}